import React, { useState, useEffect } from "react";
import { Github, FileText, Menu, X, ArrowUpRight } from "lucide-react";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -80;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      setIsMobileOpen(false);
    }
  };

  return (
    <header className={`site-header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="container header-container">
        
        {/* BRAND IDENTITY */}
        <div className="header-brand" onClick={() => scrollTo("hero")}>
          <span className="brand-name">Prem Bhausaheb Gore</span>
          <span className="status-pill">
            <span className="pulse-dot"></span>
            Available for Work
          </span>
        </div>

        {/* DESKTOP NAVIGATION */}
        <nav className="desktop-nav">
          <button onClick={() => scrollTo("work")} className="nav-link">Selected Work</button>
          <button onClick={() => scrollTo("live-products")} className="nav-link">Live Products</button>
          <button onClick={() => scrollTo("experience")} className="nav-link">Experience</button>
          <button onClick={() => scrollTo("capabilities")} className="nav-link">Capabilities</button>
          <button onClick={() => scrollTo("technology")} className="nav-link">Tech Stack</button>
          <button onClick={() => scrollTo("about")} className="nav-link">About</button>
          <button onClick={() => scrollTo("contact")} className="nav-link">Contact</button>
        </nav>

        {/* HEADER ACTIONS */}
        <div className="header-actions">
          {/* GITHUB LINK */}
          <a
            href="https://github.com/premgore"
            target="_blank"
            rel="noopener noreferrer"
            className="action-icon-btn"
            title="Prem Gore GitHub Profile"
            aria-label="GitHub Profile"
          >
            <Github size={19} />
          </a>

          {/* RESUME BUTTON */}
          <a
            href="/resume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-resume-header"
            title="View Authoritative Resume (PDF)"
          >
            <FileText size={15} />
            <span>Resume</span>
          </a>

          {/* GET IN TOUCH CTA */}
          <button
            onClick={() => scrollTo("contact")}
            className="btn-contact-header"
          >
            <span>Let's Talk</span>
            <ArrowUpRight size={14} />
          </button>

          {/* MOBILE TOGGLE */}
          <button
            className="mobile-toggle"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="Toggle navigation menu"
          >
            {isMobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

      </div>

      {/* MOBILE DRAWER */}
      <div className={`mobile-drawer ${isMobileOpen ? "drawer-open" : ""}`}>
        <div className="mobile-drawer-inner">
          <nav className="mobile-nav-links">
            <button onClick={() => scrollTo("hero")}>00. Introduction</button>
            <button onClick={() => scrollTo("work")}>01. Selected Work</button>
            <button onClick={() => scrollTo("live-products")}>02. Live Products</button>
            <button onClick={() => scrollTo("experience")}>03. Experience</button>
            <button onClick={() => scrollTo("capabilities")}>04. Capabilities</button>
            <button onClick={() => scrollTo("technology")}>05. Tech Stack</button>
            <button onClick={() => scrollTo("about")}>06. Background &amp; Education</button>
            <button onClick={() => scrollTo("contact")}>07. Contact</button>
          </nav>

          <div className="mobile-drawer-actions">
            <a
              href="/resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline mobile-btn"
            >
              <FileText size={16} />
              View / Download Resume (PDF)
            </a>
            <a
              href="https://github.com/premgore"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary mobile-btn"
            >
              <Github size={16} />
              View GitHub Profile
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;